// Copyright (C) 2024-2025 Skylark Drones

import { mapGetters } from 'vuex'

import routesName from '@/router/routesName'
import {
  daysToCompanyPlanExpiry,
  isCompanyPlanExpiryClose
} from '@/utils/common/subscription'

export default {
  computed: {
    ...mapGetters(['user', 'currentActiveOrganization']),
    isOwner() {
      return this.currentActiveOrganization.role === 'owner'
    },
    daysToExpiry() {
      return daysToCompanyPlanExpiry(
        this.currentActiveOrganization.subscription?.valid_till
      )
    },
    isPlanAboutToExpire() {
      return isCompanyPlanExpiryClose(
        this.currentActiveOrganization.subscription?.valid_till,
        this.currentActiveOrganization.subscription?.status
      )
    },
    navigateToPlan() {
      const shouldShowBillingTab =
        this.currentActiveOrganization.invoice_count > 0

      const tabKey = shouldShowBillingTab ? 'billing' : 'plans'

      const page = {
        name: routesName.SettingsPage,
        params: {
          companyId: this.currentActiveOrganization.id,
          tabKey
        }
      }

      if (shouldShowBillingTab && !this.isPlanAboutToExpire) {
        page.query = { openSubscriptionDialog: true }
      }

      if (this.user) {
        return page
      }

      return { name: 'PlansDetailsPage' }
    }
  }
}
